import React, { memo, ReactNode } from "react";

import classNames from "classnames";
import BootstrapButton from "react-bootstrap/Button";

import { AnyObject } from "../../interfaces/anyObject";
import NavigationLink from "../navigationLink/navigationLink";

import "./button.scss";

interface ButtonProps extends AnyObject {
  children: ReactNode;
  className?: string;
  compressed?: boolean;
  size?: "sm" | "lg";
}

const Button: React.FC<ButtonProps> = ({
  children,
  className = undefined,
  compressed = false,
  size = undefined,
  ...buttonProps
}) => (
  <BootstrapButton
    as={NavigationLink}
    typeOverwrite={buttonProps.type}
    className={classNames(className, { compressed: compressed && size === "sm" })}
    size={size}
    {...buttonProps}
  >
    {children}
  </BootstrapButton>
);

export default memo(Button);
